import { CartPromotionCode } from "@omni/types/api/cart/bff/shared/cartPromotionCode.model";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { isEmpty } from "lodash-es";
import { useEffect, useState } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { PromotionInputField } from "./promotionInput/promotionInputField.component";
import { PromotionList } from "./promotionList/promotionList.component";

type Props = {
    children?: string;
    promotionCodes: Array<CartPromotionCode>;
    isLoading: boolean;
    cartHasItems: boolean;
    addPromotionCode: (values: string, bonusCardNumber?: string) => void;
    removePromotionCode: (code: string) => void;
};

const Discount = ({
    promotionCodes,
    removePromotionCode,
    addPromotionCode,
    isLoading,
    cartHasItems
}: Props) => {
    const { t } = useGranite();
    const [active, setActive] = useState(promotionCodes.length > 0);

    useEffect(() => {
        return function cleanUp() {
            setActive(false);
        };
    }, []);

    return (
        <>
            {cartHasItems && (
                <>
                    {active && (
                        <div className={cn("tw:flex tw:flex-col")}>
                            <PromotionInputField
                                addPromotionCode={addPromotionCode}
                                loading={isLoading}
                                setActive={setActive}
                                autofocus={isEmpty(promotionCodes)}
                            />
                            <PromotionList
                                promotions={promotionCodes}
                                removePromotionCode={removePromotionCode}
                            />
                        </div>
                    )}
                    {!active && (
                        <Button
                            className={cn(
                                "tw:relative tw:px-2 tw:pr-4 tw:pl-2 tw:md:px-0 tw:md:py-2",
                                "tw:group"
                            )}
                            test="discount-button-fillInDiscountCode"
                            color="link"
                            type="button"
                            onClick={() => setActive(true)}
                        >
                            <div
                                className={cn(
                                    "tw:md:after:hidden tw:md:before:hidden tw:absolute",
                                    "tw:h-full tw:w-full tw:top-0 tw:left-0",
                                    "tw:after:content-[''] tw:after:text-right tw:after:pr-6 tw:after:absolute",
                                    "tw:leading-[100%]",
                                    "tw:after:bg-white tw:after:h-full tw:after:w-full tw:after:top-0 tw:after:left-0",
                                    "tw:after:[clip-path:polygon(0%_0%,90.1%_0%,99.8%_50%,90.1%_100%,0%_100%)]",
                                    "tw:before:content-[''] tw:before:absolute tw:before:bg-primary tw:before:-top-px tw:before:-left-px",
                                    "tw:before:h-[calc(100%+2px)] tw:before:w-[calc(100%+2px)]",
                                    "tw:before:[clip-path:polygon(0%_0%,90%_0%,100%_50%,90%_100%,0%_100%)]"
                                )}
                            ></div>
                            <i
                                className={cn(
                                    "las la-tags tw:pr-1 tw:hidden tw:md:inline"
                                )}
                            />
                            <span
                                className={cn(
                                    "tw:relative tw:inline-block tw:pr-2 tw:group-hover:underline tw:md:inline tw:md:pr-0"
                                )}
                            >
                                {t(
                                    "general.checkout.discount.label.fillInDiscountCode"
                                )}
                            </span>
                            <span
                                className={cn(
                                    "tw:relative tw:inline-block tw:md:hidden tw:group-hover:no-underline"
                                )}
                            >
                                ●
                            </span>
                        </Button>
                    )}
                </>
            )}
        </>
    );
};

export { Discount };
